var _totalSpent1;
var _totalSpent2;
var _totalSpent3;
var _totalSpent4;

var main_num;
var model_num;
var year_num;
var product_add = {
  "warranty": "",
  "trapofix": "",
  "classic_plus": "",
  "trapo_back": "",
  "vid": ""
};

var product_confirm =  {
  "Title": "",
  "Trapo Back": "",
  "Classic Plus": "",
  "Trapo Fix": "",
  "Warranty": ""
}

var product_confirmation_price = {
  "Trapo Back": "",
  "Classic Plus": "",
  "Trapo Fix": "",
  "Warranty": ""
}
var buyTrapoBack = false;
var mat_carousel;
var $template;
var variant_option;
var _sku;
var _isLogin;

var brand = {
  "num" : "",
  "href": ""
};
var model = {
  "num" : "",
  "href": ""
};
var year = {
  "num" : "",
  "href": ""
};

$(function(){
  var _template = $('#js_template').val();

  _isLogin = $('#js_customer').val();
  _customerTags = $('#js_customer').attr('data-tags');


  if (sessionStorage.getItem("isAgent") != "true") {
    $('.modal-login').show();
  }
  $template = $('#js_template').val();

  //SemiCircle Progress bar
  if (_template.includes('customers/account') && (_customerTags.includes('Platinum') || _customerTags.includes('Gold') || _customerTags.includes("Starter") || _customerTags.includes('Silver') || _customerTags.includes('VIP') || _customerTags.includes('Exclusive') )) {
    progressBarJS();
    initiateProgressBar();
  }

  // Global function call
  findSecondButtonBindEvent();

  if ($template.includes('index')) {
    $('.cocoen').cocoen();
  }
  if ($template.includes('product')) {
    toggleSelect();
    bindDropdownWithSwatch();
    bindCheckScroll();
    $("select.transmission_dropdown").each(function () {
      $(this).val($(this).find('option[selected]').val());
    });

    if (!(window.location.href).toString().includes('?variant=')) {
      var $carousel = $('.js-product-gallery').flickity();
      $carousel.flickity( 'select', 0)
    }
  }

  if ($template.includes('search')) {
    searchTemplateDisplay();
  }

  $('.mini_cart').on('click', function(){
    window.location.href="/cart";
  })

  // click to hide/show accordion
  $('.question_info').on('click',function(){
    $this = $(this);
    $this.parent().parent().find('.info-label').fadeToggle().css('display', 'block');
    if ($(window).width() >= 799) {
      $('.mobile-div').remove();
    }
    else{
      $('.desktop-div').remove();
    }
  })

  // $('.question_info').click();



  // Accordion
  var allPanels = $('.accordion > dd').hide();

  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(":visible")) {
     $(this).parent().find('small.right').html('&#9660;');
     $(this).parent().next().slideDown();
    } else if($(this).parent().next().is(":visible")){
      $(this).parent().next().slideUp();
      $(this).parent().next('.accordion small.right').html('&#9658;');
      $(this).next('small.right').html('&#9658;');
      if($(this).find('small.right').html('&#9660;')) {
        $(this).find('small.right').html('&#9658;');
      } else if($(this).find('small.right').html('&#9658;')) {
        $(this).find('small.right').html('&#9660;');
      }
    }
        return false;
  });

  if (document.getElementById("description_accordion_arrow")) {
    document.getElementById("description_accordion_arrow").click();
  }


  memberSpecialPage();

})

memberSpecialPage = () => {
  var _handle = $("#member_page_handle").val();
  var _page = $("#member_page_handle").attr('data-page');
  var _tags = $("#member_page_handle").attr('data-customer-tags');

  console.log(_tags, _handle, _page);
  // if (_handle !== 'undefined' && (_tags.includes("Starter") || _tags.includes("Silver") || _tags.includes("Gold") || _tags.includes("Platinum") )) {
  //   _handle = _handle.split(',');
  //   for (var i = 0; i < _handle.length; i++) {
  //     if (_page == _handle[i]) {
  //       console.log('S');
  //     }
  //   }
  // }
}

// Window onload function -- Can uncomment if necessary
$(window).on("load",function(){
  $('.gif-loader').fadeOut();
})

bindDropdownWithSwatch = () => {
  $('.transmission_dropdown').on('change', function(){
    var _ = $(this).val();
    $('label.swatch-'+_).click();
    // variant image function
    imageUpdater(true);
  })
}

customerClick = () => {
  window.location.href = 'https://my.trapo.asia';
}

agentClick = () => {
  sessionStorage.setItem("isAgent", "true");
  $('.modal-login').hide();
}

changeFixPrice = (evt) => {
  var $this = evt;
  var _pricing =$this.data('pricing');
  var _mainpricing =$this.data('discounted');
  var _length = $('.trapofix-swatch.selected').length;
  if (_length == 0) {
    $('.main-price').show().addClass('inline');
    $('.sub-price').hide().removeClass('r-inline');
    $('.sub-mainprice').hide().removeClass('r-inline');
  }
  else{
    $('.main-price').hide().removeClass('inline');
    $('.sub-mainprice').text(Shopify.formatMoney(_mainpricing, $('body').data('money-format'))).show().addClass('r-inline');
    $('.sub-price').text(_pricing).show().addClass('r-inline');
  }

}

searchTemplateDisplay = () => {
  var _type = sessionStorage.getItem('collection_title');
  $('.'+_type).show();
}

showYTModal = (div_name) => {
  $('#yt_modal').show();
  $('.all-vid').hide();
  $('.'+div_name+'-vid').show();
}

hideYTModal = () => {
  $('#yt_modal').hide();
}

cartAddCart = (id) => {
  CartJS.addItem(id);
  setTimeout(() => location.reload(), 1000);
}

packData = (items) => {
  var new_data = [];
  var _currentHandle = $('#collection_handle').val();
  // Dont't show specific collection and addons
  for (var i = 0; i < items.results.length; i++) {
    var toAdd = false;
    for (var j = 0; j < items.results[i]['collections'].length; j++) {
      if (items.results[i]['collections'][j]['handle'] == _currentHandle)
        if (toAdd == false) {
          new_data.push(items.results[i]);
          toAdd = true;
        }
    }
  }

  return new_data;
}

bindCheckScroll = () => {
  // Initial state
  var scrollPos = 0;
  // adding scroll event

  window.addEventListener('scroll', function(){
    var scrollLeft = $(window).scrollLeft() ;
    var scrollTop = $(window).scrollTop() ;
    // detects new state and compares it with the new one
    if ((document.body.getBoundingClientRect()).top > scrollPos)
      $(window).width() < 1025 ? $('.mobile-sticky-price').fadeOut() : $('.sticky-price').fadeOut()
  	else {
      if ($(window).width() < 1025) {
        if (scrollTop > 50) {
          $('.mobile-sticky-price').fadeIn();
        }
      }
      else {
        $('.sticky-price').fadeIn();
      }
    }


  	scrollPos = (document.body.getBoundingClientRect()).top;
  });
}

checkSelectedVariant = () => {
  var _id = $('#product_selected').val();
  if ((window.location.href).toString().includes('?variant=')) {
    console.log('yo true');
    _id = (((window.location.href).toString().split('?'))[1].split('='))[1];
  }

  product_add['vid'] = _id;
}

removeProduct = (evt) => {
  // NProgress.start();
  var _cart;
  var _bundleid = ($(evt).data('bundleid')).toString().split(',');
  var _currentid = $(evt).data('id');
  var _currentkey = $(evt).data('key');
  var _backid = $(evt).data('backid');
  var _prodtype = $(evt).data('prodtype');
  var _Property = {};


  // Call cart json
  $.getJSON('/cart.js', function(cart) {
    _cart = cart;

    for (var i = 0; i < _cart.items.length; i++) {
      for (var j = 0; j < _bundleid.length; j++) {
        if (cart.items[i].id == _bundleid[j]) {
          _Property[cart.items[i].key] = 0;
        }

        if (_prodtype == 'TRAPO BACK CLASSIC') {
          if (cart.items[i].key == _currentkey && !_Property[_currentkey] &&  cart.items[i].properties['combo'] != 'yes') {
            _Property[cart.items[i].key] = 0;
            // CartJS.updateItem(i+1, cart.items[i].quantity-1);
          }
        }
        else{
          if (cart.items[i].key == _currentkey && !_Property[_currentkey]) {
            _Property[cart.items[i].key] = 0;
          }
        }
      }

      if (_backid == cart.items[i].id && cart.items[i].properties['combo'] == 'yes') {
        // CartJS.updateItem(i+1, cart.items[i].quantity-1);
        _Property[cart.items[i].key] = 0;
      }
    }

    console.log(_Property);
    CartJS.updateItemQuantitiesById(_Property);

    setTimeout(() => {
      // NProgress.done();
      location.reload()
    }, 2000);
  });
}



findSecondButtonBindEvent = () => {
  $('.second_button').each(function(){
    var $this = $(this);
    var _text = ($this.text()).toLowerCase();
    if (_text.includes('customise it')) {
      $this.addClass('cursor');
      $this.on('click touchstart',function(){
        toggleOverlayBody();
      })
    }
  })
}

toggleOverlayBody = () =>{
  $('.overlay-body').toggle();
}

nextPrevStep = (div) => {
 var current_step = $(event.currentTarget).attr('data-steps');
 var index = $(event.currentTarget).data('index');
 var _text = $(event.currentTarget).text().toLowerCase();
 var _noback = $('#noback').val();
 var _checktype = $('#js_product_type').val();
 $('.'+div).show();
 $('.'+current_step).hide();

 if ($(event.currentTarget).hasClass('is-next')) {
   // If trapo back add two steps
   _noback == 'true' && current_step == "product_form_step" ?  next(index,index+1) : next(index,index+1) ;
 }
 else if ($(event.currentTarget).hasClass('is-previous')) {
   // If trapo back minus two steps
   if (_checktype.includes('trapo hex') || _checktype.includes('trapo eco')) {
     _noback == 'true' && (current_step == "confirmation")?  next(index-3,index-2) : next(index-2,index-1);
   }
   else {
     _noback == 'true' && (current_step == "classic-plus")?  next(index-3,index-2) : next(index-2,index-1);
   }

 }

 // Build confirmation page
 var _isHexEco = index == 2 && current_step == "trapo-back";
 var _noBackHexEco = $('.isBack').val();

 if (_noBackHexEco) {
   buildConfirmation();
 }
 if ($(event.currentTarget).hasClass('is-next') && (_isHexEco || current_step == 'warranty' )) {
   buildConfirmation();
 }
}

// Num1 is always show
// Num2 is always hide
function next(num1, num2) {
  $('.progress-step').removeClass('is-active is-complete');
  for (var i = 1; i <= num1; i++) {
    $('#step'+i).addClass('is-complete');
  }

  $('#step'+num2).addClass('is-active');
}


toggleSelect = () => {
  $('.combo_addons img.not-swatch').each(function(){
    $(this).on('click', function(){
      $(this).toggleClass('selected');
      var _item = $(this).data('item');
      if (_item == 'trapo_back'){
        changeWarrantyLabelPrice($(this));
      }
      calculatePackagePrice();
    })
  })

  $('.trapofix-swatch').each(function(){
    $(this).on('click', function(){
      $(this).siblings().removeClass('selected');
      $(this).toggleClass('selected');
      calculatePackagePrice();
      changeFixPrice($(this));
    })
  })
}

changeWarrantyLabelPrice = (element) => {
  element.hasClass('selected') ? buyTrapoBack = true : buyTrapoBack = false;
  var _wo = checkWarranty(element);
  if (_wo) {
    if (_wo != "" && _wo != "undefined")
      var _price;
      _wo.data('discounted') !== void(0) ? _price = _wo.data('discounted') : _price = _wo.data('price');

      $('.warranty_pricing').text(Shopify.formatMoney(_price, $('body').data('money-format')));
      if ($('.warranty_tiers_discount').val() != "undefined") {
        $('.discounted_warranty_pricing').text(Shopify.formatMoney(_price * $('.warranty_tiers_discount').val(), $('body').data('money-format')));
      }
  }

}

toggle360 = () => {
  $('.turntable').toggle();
  $('.js-product-gallery.product_gallery').toggle();
  $('.turntable').css('display') == 'none' ? $('.button-360').text('360 images') : $('.button-360').text('More Images');
  if ($('.js-product-gallery.product_gallery').css('display') != 'none') {
    setTimeout(function(){
      imageUpdater(true);
    },500);
  }
}

calculatePackagePrice = () => {
  // get main price
  var main_price = $('.customise_money').data('price');
  var main_price2 = $('.discounted_money').data('mainprice');

  $('.combo_addons img.selected').each(function(){
    var $this = $(this);
    var _p = $this.data('price');

    var _item = $this.data('item');
    var warranty_object = _item == "warranty" ? checkWarranty($this) : "";

    warranty_object == "" ? main_price2 += $this.data('discounted') : main_price2 += warranty_object.data('discounted');

    warranty_object == "" ? main_price += _p : main_price += warranty_object.data('price');

  })


  $('.trapofix-swatch.selected').each(function(){
    var _p = $(this).data('price');
    var _p2 =  $(this).data('discounted');
    main_price += _p;
    main_price2 += _p2;
  })

  main_price = Shopify.formatMoney(main_price, $('body').data('money-format'))
  main_price2 = Shopify.formatMoney(main_price2, $('body').data('money-format'))
  $('.customise_money .money').text(main_price);
  $('.discounted_money .money').text(main_price2);
}


checkProductField = () => {

  var _email = $('#product_customer_email').val();
  var _name = $('#product_customer_name').val();
  var _phone = $('#product_customer_phone').val();

  // console.log(_email, _name, _phone);
  _phone.length == 0 || _name.length == 0 ? $('.email_error').show() : $('.email_error').hide() ;

  _email.includes('@') && _email.includes('.com') ? $('.special_email_error').hide() : $('.special_email_error').show() ;

  var iscontain =  _name.length > 0 && _phone.length > 0 && _email.includes('@') && _email.includes('.com') ? true : false ;

  return iscontain;
}

addAll = (evt) => {
  var _thisbutton = $(evt);
  _thisbutton.addClass('disabled-addtobag').prop('disabled', true);

  var check_productfield = checkProductField();

  if (check_productfield) {
    product_add['warranty'] = "";
    product_add['trapofix'] = "";
    product_add['classic_plus'] = "";
    product_add['trapo_back'] = "";

    var _appendid = '';
    var _mainitem = '';
    var _steps = $(event.currentTarget).data('steps');
    var _trapofixprice = 0;
    var _warrantyprice = 0;

    // checkSelectedVariant();
    if ($('.trapofix-swatch.selected').length != 0) {
      _trapofixprice = $('.trapofix-swatch.selected').data('pricing'); // Trapo fix breakdown price at cart page
      product_add['trapofix']=$('.trapofix-swatch.selected').data('id');
      _appendid += product_add['trapofix'] + ",";
      _mainitem += "Trapo Fix,";
    }

    var _length = $('.combo_addons img.selected').length - 1;
    $('.combo_addons img.selected').each(function(index){
      var _item = $(this).data('item');
      if (_item == 'trapo_back') {
        buyTrapoBack = true;
        product_add[_item] = $('div.trapoback_div').find('.'+variant_option).val();
        // _appendid += product_add[_item] +',';
        _mainitem += "Trapo Back";
        index < _length ? _mainitem += ',' : _mainitem = _mainitem;
      }
      else if (_item == 'warranty') {
        var _ = checkWarranty($(this));
        _appendid += _.val() +',';
        _mainitem += "Warranty";
        _warrantyprice = _.data('pricing'); // warranty price for breakdown price at cart page
        index < _length ? _mainitem += ',' : _mainitem = _mainitem;
      }
      else if (_item == 'classic_plus'){
        product_add[_item] = $(this).data('id');
        _appendid += product_add[_item] +',';
        _mainitem += "Classic Plus";
        index < _length ? _mainitem += ',' : _mainitem = _mainitem;
      }
    })

    // Need to pass in a new params where if Trapo fix or Warranty is purchase
    buildParamsAndAdd(product_add, _appendid, _steps, _mainitem, _trapofixprice, _warrantyprice);

    setTimeout(function(){
      _thisbutton.removeClass('disabled-addtobag').prop('disabled', false);
    },2000)
  }
  else {
    console.log('display error please');
    _thisbutton.removeClass('disabled-addtobag').prop('disabled', false);
  }

}

buildConfirmation = () => {
  $('.combo_addons img.selected').each(function(){
     var $this = $(this);
     var _item = $this.data('item');

     if (_item == 'warranty') {
       var _ = checkWarranty($this);
       product_confirm['Warranty'] = _.data('title');
       product_confirmation_price['Warranty'] = _.data('pricing');
     }
     else if (_item == 'trapo_back') {
       product_confirm['Trapo Back'] = $this.data('ptitle') + " " + $this.data('title');
       product_confirmation_price['Trapo Back'] = $this.data('pricing');
     }
     else if (_item == 'classic_plus') {
       product_confirm['Classic Plus'] = $this.data('ptitle');
       product_confirmation_price['Classic Plus'] =$this.data('pricing');
     }
  })

  if ($('.trapofix-swatch.selected').length != 0) {
    product_confirm['Trapo Fix']=$('.trapofix-swatch.selected').data('title');
    product_confirmation_price['Trapo Fix'] =$('.trapofix-swatch.selected').data('pricing');
  }

  var _ = '<div class="p-l-10 p-r-10 p-t-10 p-b-10">';
  var _checktype = $('#js_product_type').val();

  // Cart page addons to skip or not
  if (_checktype.includes('trapo hex')) {
    product_confirm['Classic Plus'] = "skip";
    product_confirm['Trapo Fix'] = "Included";
    product_confirm['Warranty'] = "Included";
  }
  else if (_checktype.includes('trapo eco')) {
    product_confirm['Classic Plus'] = "skip";
    product_confirm['Trapo Fix'] = "skip";
    product_confirm['Warranty'] = "skip";
  }
  else if (_checktype.includes('trapo back')) {
    product_confirm['Trapo Fix'] = "skip";
    product_confirm['Trapo Back'] = "skip";
    product_confirm['Classic Plus'] = "skip";
  }

  for (var key in product_confirm) {
    // check if the property/key is defined in the object itself, not in parent
    if (product_confirm.hasOwnProperty(key) ) {
      if (key == 'Title') {
        // split the name
        var b = $('.footer-pricing .customise_money').data('pricing');
        if (_checktype.includes('trapo back')) {
          var _s = product_confirm[key].split('/');
          _ += "<div class='m-b-15'><span class='m-fontSize-12 fontSize-s border-bottom-white m-b-10 m-t-20'>Mat Customisation</span><br><p class='m-b-0 m-t-10'>Base Colour: "+_s[0].trim()+"</p><p class='half-width inline m-b-0'>Lining Colour: "+_s[1].trim()+"</p><p class='half-width inline m-b-0'>"+b+"</p></div><span class='m-fontSize-12 fontSize-m border-bottom-white m-b-10 m-t-20' style='display: block; width: 24%;'>Add Ons</span>"
        }
        else {
          var _s = product_confirm[key].split('/');
          _ += "<div class='m-b-15'><span class='m-fontSize-12 fontSize-s border-bottom-white m-b-10 m-t-20'>Mat Customisation</span><br><p class='m-b-0 m-t-10'>Base Colour: "+_s[0].trim()+"</p><p class='m-b-0'>Transmission: "+_s[1].trim()+"</p><p class='m-b-0 half-width inline'>Lining Colour: "+_s[2].trim()+"</p><p class='half-width inline m-b-0'>"+b+"</p></div><span class='m-fontSize-12 fontSize-m border-bottom-white m-b-10 m-t-20' style='display: block; width: 24%;'>Add Ons</span>"
        }


      }
      else{
        if (product_confirm[key] != 'skip') {
          if (product_confirm[key] == 'Included') {
            product_confirm[key] != "" ? _ += "<span>"+key+": Included</span><br>" : _ += "<span>"+key+": No</span><br>"
          }
          else{
            var $pp = product_confirmation_price[key] != "" ? "<span class='half-width inline'>"+product_confirmation_price[key]+"</span>" : "";
            product_confirm[key] != "" ? _ += "<span class='half-width inline'>"+key+": Yes </span>"+$pp+"<br>" : _ += "<span>"+key+": No</span><br>"
          }

        }
      }

    }
  }

  _+= "<span class='m-fontSize-12 fontSize-m m-b-10 m-t-20' style='display: block; width: 100%;'>SKU: "+ _sku +"</span></div>";
  $('.confirmation_product').empty();
  $('.confirmation_product').html(_);
  resetProductConfirm();
}
resetProductConfirm = () => {
  product_confirm['Trapo Back'] = "";
  product_confirm['Classic Plus'] = "";
  product_confirm['Trapo Fix'] = "";
  product_confirm['Warranty'] = "";
}

variantTitle = (va) => {
  product_confirm['Title'] = va.title;
  product_add['vid'] = va.id;
  _sku = va.sku;
  var _template = $('#js_template').val();
  if (_template.includes('product.mat') || _template.includes('product.eco') || _template.includes('product.hex')) {
    variant_option = va.option1.toLowerCase() + '-' + va.option3.toLowerCase();
  }

  if (_template.includes('product.mat') || _template.includes('product.back') || _template.includes('product.hex') || _template.includes('product.eco')) {
   // retrieve360(va);
  }
}

retrieve360 = (selected_variant) => {
  $('.turntable-360').empty();
  var _type = $('#js_product_type').val();
  var _template = $('#js_template').val();
  if (_template.includes('product.back')) {
    var combine_variant = selected_variant.option1.toLowerCase() + '_' +selected_variant.option2.toLowerCase();
  }
  else {
    var combine_variant = selected_variant.option1.toLowerCase() + '_' +selected_variant.option2.toLowerCase() + '_' +selected_variant.option3.toLowerCase().replace(/\s/g, '');
  }

  var _html = '';
  $('.'+combine_variant).children().each(function(){
    var _this = $(this);
    _html+= '<li data-img-src="http:'+ _this.val() +'"></li>';
  })

  $('.turntable-360').html(_html);

  $('#myTurnTable').turntable({
    axis: 'x, y, or scroll',
    reverse: true,
    scrollStart: 'top, middle, or bottom' // only necessary if axis = 'scroll'
  });

}

buildParamsAndAdd = (product_add, line_item_allvid, step, mainitem, trapofix_price, warranty_price) => {
  var params = [];
  var $qty = parseInt($('.jsc-quantity').val());

  for (var property in product_add) {
    if (product_add.hasOwnProperty(property)) {
        var _property = {};
        if (property == 'trapo_back') {
          _property['combo'] = 'yes';
        }
        else if (property == 'vid') {
          _property['bundle'] = line_item_allvid;
          _property['Bundle Product'] = mainitem;
          _property['Final Price'] = $('.sticky-price .customise_money .money').text();

          // Include trapofix / warranty pricing
          _property['Trapo Fix Price'] = trapofix_price ;
          _property['Warranty Price'] = warranty_price ;

          // Trapo back id
          _property['Trapo BackID'] = product_add['trapo_back']
          _property['Customer Email'] = $("#product_customer_email").val() ;
          _property['Customer Name'] = $("#product_customer_name").val() ;
          _property['Customer Phone'] = $("#product_customer_phone").val() ;
          // If trapoback classic then add is trapo back main classic

          console.log(_property);
        }

        if (product_add[property] != "") {
          params.push(
            {
              'id' : product_add[property],
              'qty': $qty,
              'properties': _property
            }
          )
        }

    }
  }

  MGUtil.begin(params);
  setTimeout(() => {
    // ajaxRefreshCart();
    $('.combo_addons img.selected').removeClass('selected');
    $('.trapofix-swatch.selected').removeClass('selected');
    $('.firstStep').show();
    $('.'+step).hide();
    window.location.href = window.root_url + "/cart";
  }, 2000);

}

checkWarranty = (ele) => {
  var _type = ele.data('type')
  var _checktype = $('#js_product_type').val();

  if (_checktype.includes('trapo back')) {
    product_add['warranty'] = $('.back').val();
    return $('.back');
  }
  else{
    if (buyTrapoBack && _type == 'trapo-classic' ) {
      product_add['warranty'] = $('.classic-back').val();
      return $('.classic-back');
    }
    else if(buyTrapoBack==false && _type == 'trapo-classic' ){
      product_add['warranty'] = $('.classic').val();
      return $('.classic');
    }

    if (buyTrapoBack && _type == 'trapo-back') {
      product_add['warranty'] = $('.back').val();
      return $('.back');
    }
  }

}

removeSingleProduct = (ele) => {
  $this = $(ele);
  CartJS.removeItemById($this.data('id'));
  setTimeout(() => location.reload(), 1000);
}

progressBarJS  = () => {

  _totalSpent1 = parseFloat($('#_totalSpent1').val());
  var _firstTierPercent = parseFloat(100000 - _totalSpent1);

  _totalSpent2 = parseFloat($('#_totalSpent2').val());
  var _secTierPercent = parseFloat(500000 - _totalSpent2);

  _totalSpent3 = parseFloat($('#_totalSpent3').val());
  var _thirdTierPercent = parseFloat(1000000 - _totalSpent3);

  _totalSpent4 = parseFloat($('#_totalSpent4').val());

  console.log(_totalSpent1, 'Dalilaaaa');
  if (_firstTierPercent) {
    $('.firstTierPercent').text(Shopify.formatMoney(_firstTierPercent, $('body').data('money-format')));
  }

  if (_secTierPercent) {
    $('.secTierPercent').text(Shopify.formatMoney(_secTierPercent, $('body').data('money-format')));
  }

  if (_thirdTierPercent) {
    $('.thirdTierPercent').text(Shopify.formatMoney(_thirdTierPercent, $('body').data('money-format')));
  }

  if (_totalSpent4) {
    $('#_totalSpent4').text(Shopify.formatMoney(_totalSpent4, $('body').data('money-format')));
  }
}

initiateProgressBar  = () => {
  var bar = new ProgressBar.SemiCircle('.semi-progressbar', {
  strokeWidth: 6,
  color: '#EEEEEE',
  trailColor: '#eee',
  trailWidth: 1,
  easing: 'easeInOut',
  duration: 1400,
  svgStyle: null,
  text: {
  value: '',
  alignToBottom: false
  },
  from: {color: '#EEEEEE'},
  to: {color: '#EE2A7B'},

  // Set default step function for all animate calls
  step: (state, bar) => {
    bar.path.setAttribute('stroke', state.color);

    console.log(_totalSpent1, 'Deeee');

    if (_totalSpent1 >= 0) {
      bar.setText('<div style="font-size:12px;">Total spent to date</div>' + Shopify.formatMoney(_totalSpent1,$('body').data('money-format')));
    }

    else if (_totalSpent2 >= 0) {
      bar.setText('<div style="font-size:12px;">Total spent to date</div>' + Shopify.formatMoney(_totalSpent2,$('body').data('money-format')));
    }

    else if (_totalSpent3 >= 0) {
      bar.setText('<div style="font-size:12px;">Total spent to date</div>' + Shopify.formatMoney(_totalSpent3,$('body').data('money-format')));
    }

    else if (_totalSpent4 >= 0) {
      bar.setText('<div style="font-size:12px;">Total spent to date</div>' + Shopify.formatMoney(_totalSpent4,$('body').data('money-format')));
    }

    bar.text.style.color = state.color;
  }
});

bar.animate(1.0);  // Number from 0.0 to 1.0

}

toggleCartWarranty = (evt) =>{
  var $this = $(evt);
  console.log($this.parents('.combo_addons').find('.jsc-cart-war-atc-container'));
  $this.toggleClass('selected');
  $this.parents('.combo_addons').find('.jsc-cart-war-atc-container').toggle();
}

addCartWarranty  = (evt, key, vid, price) =>{
  // Disable this button after first click
  $(evt).prop('disabled',true);

  $.getJSON('/cart.js', function(cart) {

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key == key) {
        var $properties = cart.items[i].properties;
        var $bundleProp = cart.items[i].properties['bundle'];
        var $bundleType = cart.items[i].properties['Bundle Product'];
        var $qty = cart.items[i].quantity;

        $properties['Warranty Price'] = price;
        $properties['bundle'] = $bundleProp + vid + ',';
        $properties['Bundle Product'] = $bundleType + ',' + 'Warranty';

        CartJS.updateItemById(key, $qty, $properties,
        {
          "success": function(data, textStatus, jqXHR){
            console.log('successsss');
            addWarrantyInCart(parseInt(vid),parseInt($qty));
          },
          "error": function(data, textStatus, jqXHR){
            console.log('fail');
          }
        });
      }
    }
  });
}

addWarrantyInCart = (vid, qty) =>{
  console.log(qty);
  CartJS.addItem(vid, qty, {},
  {
    "success": function(data, textStatus, jqXHR) {
        console.log('Added!');
        location.reload();
    },
    "error": function(jqXHR, textStatus, errorThrown) {
        console.log('Error: ' + errorThrown + '!');
    }
  });
}

jscRemoveAddons = (addonID, key, qty, price) =>{
  var $parseAddonID = parseInt(addonID);

  jQuery.getJSON('/cart.js', function(cart) {
    // We can access cart info
    for (var i = 0; i < cart.items.length; i++) {
      var $item = cart.items[i];
      var $itemVid = $item.variant_id;
      if ($parseAddonID == $itemVid) {
        var $updatedQty = $item.quantity - qty;
        var $itemKey = $item.key;
        var $itemHandle = $item.handle;

        var $itemKeySame = false;
        console.log('key');
        for (var i = 0; i < cart.items.length; i++){
          var $itemcheck = cart.items[i];
          var $itemKeycheck = $itemcheck.key;
          console.log($itemKey);
          if ($itemKeycheck == key){
            $itemKeySame = true;
          }
        }

        if($itemKeySame == true){
          console.log('can remove');
        // updateMainProduct(key, $itemHandle, $itemVid, price, cart);
        CartJS.updateItemById($itemKey, $updatedQty, {},
        {
          "success": function(data, textStatus, jqXHR){
            console.log('successsss');
            updateMainProduct(key, $itemHandle, $parseAddonID, price, cart);
          },
          "error": function(data, textStatus, jqXHR){
            console.log('fail');
          }
        });

      }else{
        location.reload();
      }

      }
    }
  });
}

updateMainProduct = (key, handle, vid, price, cart) =>{
  for (var i = 0; i < cart.items.length; i++) {
    var $item = cart.items[i];
    var $itemKey = $item.key;

    if ($itemKey == key) {
      var $itemQty = $item.quantity;
      var $itemProp = $item.properties;
      var $getPTitleArray = $itemProp['Bundle Product'].split(',');
      var $getVidArray = $itemProp['bundle'].split(',');
      var $finalPrice = $itemProp['Final Price'];
      var $itemVid = vid.toString();

      var $finalDouble = parseFloat($finalPrice.replace('RM', ''));
      var $priceDouble = parseFloat(price.replace('RM', ''));

      var $newFinalPrice = $finalDouble - $priceDouble;
      $itemProp['Final Price'] = 'RM'+$newFinalPrice.toFixed(2);

      var $removedVariant = $.grep($getVidArray, function(value) {
                            return value != $itemVid;
                          });

      if (handle.includes('back')) {
        var $removedArray = $.grep($getPTitleArray, function(value) {
                              return value != 'Trapo Back';
                            });
        $itemProp['Trapo BackID'] = '';
        $itemProp['Bundle Product'] = $removedArray.toString();

      }
      if (handle.includes('fix')) {
        var $removedArray = $.grep($getPTitleArray, function(value) {
                              return value != 'Trapo Fix';
                            });
        $itemProp['Trapo Fix Price'] = '0';
        $itemProp['Bundle Product'] = $removedArray.toString();
        $itemProp['bundle'] = $removedVariant.toString();
      }

      if (handle.includes('plus')) {
        var $removedArray = $.grep($getPTitleArray, function(value) {
                              return value != 'Classic Plus';
                            });
        $itemProp['Bundle Product'] = $removedArray.toString();
        $itemProp['bundle'] = $removedVariant.toString();
      }

      if (handle.includes('warranty')) {
        var $removedArray = $.grep($getPTitleArray, function(value) {
                              return value != 'Warranty';
                            });
        $itemProp['Warranty Price'] = '0';
        $itemProp['Bundle Product'] = $removedArray.toString();
        $itemProp['bundle'] = $removedVariant.toString();
      }

      CartJS.updateItemById($itemKey, $itemQty, $itemProp,
      {
        "success": function(data, textStatus, jqXHR){
          console.log('successsss 2');
          setTimeout(function(){
            location.reload();
          },1200);
        },
        "error": function(data, textStatus, jqXHR){
          console.log('fail 2');
        }
      });
    }
  }
}
